import apiConfig from "src/utils/apiConfig";

export const FETCH_TABLE_STATEMENT = "vehiclemaster/fetchVehicleMasterRequest";
export const UPDATE_PAID_OWNER = "vehiclemaster/updatePaidOwnerRequest";

export const fetchdata = (cabId: string | number, month: string) => {
  const queryParams = new URLSearchParams({
    cabId: String(cabId),
    month,
  });

  const endpoint = `${apiConfig.GETVEHICLEMASTER}/?${queryParams.toString()}`;

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_TABLE_STATEMENT,
    payload: apiobject,
  };
};

export const updatepaidtoOwnerData = (payload: any) => {
  const apiObject: any = {
    method: "POST",
    authentication: true,
    endpoint: apiConfig.UPDATEDATA,
    body: payload,
  };
  return {
    type: UPDATE_PAID_OWNER,
    payload: apiObject,
  };
};
